import {
	RFQ_LIST,
	RFQ_LIST_SUCCESS,
	INPUT_CHANGEVALUE,
	SELECT_CHANGEVALUE,
	RFQ_NO_SELECT_CHANGEVALUE,
	RFQ_ROW_DATA,
	RFQ_ROW_DATA_SUCCESS,
	QITEM_REMOVE,
	Q_VENDORS_LIST,
	Q_VENDORS_LIST_SUCCESS,
	ITEM_QTY_CHANGEVALUE,
	ITEM_UNIT_CHANGEVALUE,
	ITEM_PRICE_CHANGEVALUE,
	ITEM_BASEPRICE_CHANGEVALUE,
	ITEM_TAXTYPE_CHANGEVALUE,
	ITEM_TAX_CHANGEVALUE,
	ITEM_GROSS_VAL_CHANGEVALUE,
	ITEM_QUALITIES_CHANGEVALUE,
	QUOTATION_ADD,
	QUOTATION_LIST,
	QUOTATION_LIST_SUCCESS,
	TOGGLE_ITEM_MENU,
	SET_PARAMS,
	FILTER_INPUT_CHANGEVALUE,
	FILTER_SELECT_CHANGEVALUE,
	Q_MODEL_LIST_OPEN,
	Q_MODEL_LIST_CLOSE,
	QOUTATION_DATA,
	QOUTATION_DATA_SUCCESS,
	LIST_LAYOUT,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	RFQ_FILTERS_LIST,
	RFQ_FILTERS_LIST_SUCCESS,
	ITEM_DISC_PERCENT_CHANGEVALUE,
	MR_CODE_DETAILS,
	MR_CODE_DETAILS_SUCCESS,
	PI_CODE_DETAILS,
	PI_CODE_DETAILS_SUCCESS,
	MR_ITEM_IMAGES,
	MR_ITEM_IMAGES_SUCCESS,
	RFQ_MR_ITEM_IMAGES_MODEL_CLOSE,
	API_ERROR,
	SRFQ_FILTERS_LIST,
	SRFQ_FILTERS_LIST_SUCCESS,
	RFQ_WITHOUT_PO_LIST,
	RFQ_WITHOUT_PO_LIST_SUCCESS,
} from "./actionTypes";

const initialState = {
	rfqList: [],
	rfqFilterList: [],
	srfqFilterList: [],
	rfqWithoutPOList: [],
	QRowData: {},
	QRfQNo: {},
	RFQrowdata: [],
	qitems: [],
	QVendorsList: [],
	QRowList: [],
	QRowListCount: 0,
	Sortvar: {
		code: "QUOTATION NO",
		createdon: "CREATED ON",
	},
	params: {
		no_of_pages: 0,
		page_size: 10,
		page: 1,
		search: "",
		currentSort: "code",
		sortOrder: "-",
	},
	layout: "list",
	showFilterRightSidebar: false,
	RFQMRItemImages: [],
	RFQMRItemImagesModel: false,
};

const Quotation = (state = initialState, action) => {
	switch (action.type) {
		case RFQ_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case RFQ_LIST_SUCCESS:
			state = {
				...state,
				rfqList: action.payload,
				loading: false,
			};
			break;

		case Q_VENDORS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case Q_VENDORS_LIST_SUCCESS:
			state = {
				...state,
				QVendorsList: action.payload,
				loading: false,
			};
			break;
		case INPUT_CHANGEVALUE:
			state = {
				...state,
				QRowData: {
					...state.QRowData,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case RFQ_NO_SELECT_CHANGEVALUE:
			state = {
				...state,
				QRfQNo: {
					...state.QRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SELECT_CHANGEVALUE:
			state = {
				...state,
				QRowData: {
					...state.QRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case RFQ_ROW_DATA:
			state = {
				...state,
				loading: true,
				QRowData: {},
				qitems: [],
			};
			break;
		case RFQ_ROW_DATA_SUCCESS:
			console.log("[Quotation Reducer] RFQ_ROW_DATA_SUCCESS - First rfqitem:", action.payload.rfqitems[0]);
			var qItems = [];
			action.payload.rfqitems.map((i) => {
				var qitem = {
					id: i.id,
					rfqitem: i.id,
					product: i.product,
					originalqty: i.qty,
					balance_qty: i.balance_qty,
					qty: i.qty,
					unit: i.unit,
					unit_id: i.unit.id,
					orderlocation: i.orderlocation,
					orderlocation_id: i.orderlocation_id,
					make: i.make,
					description: i.description,
					discount: 0,
					discountpercent: 0,
					qualities: i.qualities || [],
					selected_qualities: [],
				};
				qItems.push(qitem);
				return i;
			});
			state = {
				...state,
				RFQrowdata: action.payload,
				qitems: qItems,
				loading: false,
			};
			break;
		case QITEM_REMOVE:
			var deleteQItems = state.qitems.map((item) => {
				if (action.payload.id === item.id) {
					item.dodelete = true;
				}
				return item;
			});
			// var filterQItems = state.qitems.filter((item) => {
			//   if (action.payload.id !== item.id) {
			//     return true;
			//   }
			//   return false;
			// });
			state = {
				...state,
				qitems: deleteQItems,
				loading: false,
			};
			break;
		case ITEM_QTY_CHANGEVALUE:
			var qitems1 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.qty = action.payload.value;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems1,
			};
			break;
		case ITEM_UNIT_CHANGEVALUE:
			var qitems2 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.unit = {
						id: action.payload.value,
						name: action.payload.label,
					};
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems2,
			};
			break;

		case ITEM_PRICE_CHANGEVALUE:
			var qitems3 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.price = action.payload.value;
					i.discount = action.payload.discount;
					i.discountpercent = action.payload.discountpercent;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems3,
			};
			break;
		case ITEM_BASEPRICE_CHANGEVALUE:
			var qitems8 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.baseprice = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
					// i.discountpercent = action.payload.discountpercent;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems8,
			};
			break;
		case ITEM_DISC_PERCENT_CHANGEVALUE:
			var qitems7 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.discountpercent = action.payload.value;
					i.price = action.payload.price;
					i.discount = action.payload.discount;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems7,
			};
			break;
		case ITEM_TAXTYPE_CHANGEVALUE:
			var qitems4 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.taxtype = {
						id: action.payload.value,
						name: action.payload.label,
					};
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems4,
			};
			break;

		case ITEM_TAX_CHANGEVALUE:
			var qitems5 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.tax = {
						id: action.payload.id,
						tax: action.payload.tax,
						name: action.payload.name,
					};
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems5,
			};
			break;
		case ITEM_GROSS_VAL_CHANGEVALUE:
			var qitems6 = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.gross = parseFloat(action.payload.net);
					i.taxamt = parseFloat(action.payload.taxamt);
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems6,
			};
			break;
		case ITEM_QUALITIES_CHANGEVALUE:
			var qitems_q = state.qitems.map((i) => {
				if (i.id === action.payload.item.id) {
					i.selected_qualities = action.payload.qualities;
				}
				return i;
			});
			state = {
				...state,
				qitems: qitems_q,
			};
			break;
		case QUOTATION_ADD:
			state = {
				...state,
				loading: true,
			};
			break;
		case QUOTATION_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case QUOTATION_LIST_SUCCESS:
			var noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			state = {
				...state,
				QRowList: action.payload.results,
				QRowListCount: action.payload.count,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
			};
			break;
		case TOGGLE_ITEM_MENU:
			var QRowList = state.QRowList?.map((i) => {
				if (i.id === action.payload) {
					i.actionMenu = !i.actionMenu;
				} else {
					i.actionMenu = false;
				}
				return i;
			});

			state = {
				...state,
				QRowList: QRowList,
			};
			break;
		case SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;
		case FILTER_INPUT_CHANGEVALUE:
			state = {
				...state,
				params: {
					...state.params,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case FILTER_SELECT_CHANGEVALUE:
			state = {
				...state,
				filterdata: {
					...state.filterdata,
					[action.payload.key]: action.payload.label,
				},
				params: {
					...state.params,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case Q_MODEL_LIST_OPEN:
			state = {
				...state,
				QlistModel: true,
			};
			break;
		case Q_MODEL_LIST_CLOSE:
			state = {
				...state,
				QlistModel: false,
			};
			break;
		case QOUTATION_DATA:
			state = {
				...state,
				loading: true,
			};
			break;
		case QOUTATION_DATA_SUCCESS:
			state = {
				...state,
				QRowData: action.payload.response,
				qitems: action.payload.response.qitems,
				loading: false,
			};
			break;
		case LIST_LAYOUT:
			state = {
				...state,
				layout: action.payload,
				loading: false,
			};
			break;
		case FILTERS_SHOW_RIGHT_SIDEBAR:
			state = {
				...state,
				showFilterRightSidebar: !state.showFilterRightSidebar,
			};
			break;
		case FILTERS_HIDE_RIGHT_SIDEBAR:
			state = {
				...state,

				showFilterRightSidebar: false,
			};
			break;
		case CLEAR_FILTER:
			state = {
				...state,
				filterdata: {},
			};
			break;
		case RFQ_FILTERS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case RFQ_FILTERS_LIST_SUCCESS:
			state = {
				...state,
				rfqFilterList: action.payload,
				loading: false,
			};
			break;
		case SRFQ_FILTERS_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case SRFQ_FILTERS_LIST_SUCCESS:
			state = {
				...state,
				srfqFilterList: action.payload,
				loading: false,
			};
			break;
		case RFQ_WITHOUT_PO_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case RFQ_WITHOUT_PO_LIST_SUCCESS:
			state = {
				...state,
				rfqWithoutPOList: action.payload,
				loading: false,
			};
			break;
		case MR_CODE_DETAILS:
			state = {
				...state,
				loading: true,
				QItemId: action.payload.ItemId,
			};
			break;

		case MR_CODE_DETAILS_SUCCESS:
			var qitems = state.QRowData.qitems.map((item, i) => {
				if (item.id === action.payload.ItemId) {
					item.mrdata = action.payload.data;
				}
				return item;
			});
			state = {
				...state,
				QRowData: { ...state.QRowData, qitems: qitems },
				loading: false,
			};
			break;
		case PI_CODE_DETAILS:
			state = {
				...state,
				loading: true,
				QItemId: action.payload.ItemId,
			};
			break;

		case PI_CODE_DETAILS_SUCCESS:
			var qitems_1 = state.QRowData.qitems.map((item, i) => {
				if (item.id === action.payload.ItemId) {
					item.pidata = action.payload.data;
				}
				return item;
			});
			state = {
				...state,
				QRowData: { ...state.QRowData, qitems: qitems_1 },
				loading: false,
			};
			break;
		case MR_ITEM_IMAGES:
			state = {
				...state,
				loading: true,
			};
			break;
		case MR_ITEM_IMAGES_SUCCESS:
			state = {
				...state,
				RFQMRItemImages: action.payload,
				loading: false,
				RFQMRItemImagesModel: true,
			};
			break;
		case RFQ_MR_ITEM_IMAGES_MODEL_CLOSE:
			state = {
				...state,
				RFQMRItemImagesModel: false,
			};
			break;
		case API_ERROR:
			state = {
				...state,
				loading: false,
			};
			break;
		default:
			state = { ...state };
			break;
	}

	return state;
};
export default Quotation;
